/* ============================================
   SOS ORDINATEUR — theme.js
   Version 1.0.0
   ============================================ */

'use strict';

/* ---- Sticky Header ---- */
(function () {
  const header = document.getElementById('site-header');
  if (!header) return;
  let lastScroll = 0;
  window.addEventListener('scroll', function () {
    const current = window.pageYOffset;
    if (current > 80) {
      header.classList.add('is-sticky');
    } else {
      header.classList.remove('is-sticky');
    }
    if (current > lastScroll && current > 200) {
      header.classList.add('header-hidden');
    } else {
      header.classList.remove('header-hidden');
    }
    lastScroll = current <= 0 ? 0 : current;
  }, { passive: true });
})();

/* ---- Menu Hamburger Mobile (event delegation = ultra-robuste) ---- */
(function () {
  function getNav()    { return document.getElementById('mobile-nav'); }
  function getToggle() { return document.getElementById('menu-toggle'); }
  function getOverlay(){ return document.getElementById('nav-overlay'); }

  function openMenu() {
    var nav = getNav(), toggle = getToggle(), overlay = getOverlay();
    if (!nav) return;
    nav.classList.add('is-open');
    if (toggle) { toggle.classList.add('is-active'); toggle.setAttribute('aria-expanded', 'true'); }
    if (overlay) overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    var nav = getNav(), toggle = getToggle(), overlay = getOverlay();
    if (!nav) return;
    nav.classList.remove('is-open');
    if (toggle) { toggle.classList.remove('is-active'); toggle.setAttribute('aria-expanded', 'false'); }
    if (overlay) overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  function toggleMenu() {
    var nav = getNav();
    if (!nav) return;
    if (nav.classList.contains('is-open')) closeMenu(); else openMenu();
  }

  // Délégation : capture les clics même si les éléments arrivent plus tard / sont remplacés
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t) return;
    // Hamburger (le bouton OU un de ses span enfants)
    if (t.closest && t.closest('#menu-toggle')) {
      e.preventDefault();
      toggleMenu();
      return;
    }
    // Croix de fermeture
    if (t.closest && t.closest('#mobile-nav-close')) {
      e.preventDefault();
      closeMenu();
      return;
    }
    // Clic sur l'overlay
    if (t.id === 'nav-overlay') {
      closeMenu();
      return;
    }
    // Sous-menus mobiles
    var dropdownLink = t.closest && t.closest('#mobile-nav .has-dropdown > a');
    if (dropdownLink) {
      e.preventDefault();
      dropdownLink.parentElement.classList.toggle('is-open');
    }
  });

  // Echap pour fermer
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
  });

  // Exposer en global pour fallback éventuel
  window.SOSMenu = { open: openMenu, close: closeMenu, toggle: toggleMenu };
})();

/* ---- FAQ Accordéon ---- */
(function () {
  const faqs = document.querySelectorAll('.faq-item');
  faqs.forEach(function (item) {
    const btn = item.querySelector('.faq-question');
    const answer = item.querySelector('.faq-answer');
    if (!btn || !answer) return;

    btn.addEventListener('click', function () {
      const isOpen = item.classList.contains('is-open');

      /* Fermer tous les autres */
      faqs.forEach(function (other) {
        if (other !== item) {
          other.classList.remove('is-open');
          const otherAnswer = other.querySelector('.faq-answer');
          const otherBtn = other.querySelector('.faq-question');
          if (otherAnswer) otherAnswer.style.maxHeight = null;
          if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
        }
      });

      if (isOpen) {
        item.classList.remove('is-open');
        answer.style.maxHeight = null;
        btn.setAttribute('aria-expanded', 'false');
      } else {
        item.classList.add('is-open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
})();

/* ---- Tabs Page Produit ---- */
(function () {
  const tabContainers = document.querySelectorAll('.product-tabs');
  tabContainers.forEach(function (container) {
    const tabs = container.querySelectorAll('.tab-btn');
    const panels = container.querySelectorAll('.tab-panel');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        const target = tab.getAttribute('data-tab');

        tabs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function (p) {
          p.classList.remove('is-active');
          p.setAttribute('hidden', '');
        });

        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        const panel = container.querySelector('[data-panel="' + target + '"]');
        if (panel) {
          panel.classList.add('is-active');
          panel.removeAttribute('hidden');
        }
      });
    });

    /* Activer le premier onglet par défaut */
    if (tabs.length > 0) {
      tabs[0].click();
    }
  });
})();

/* ---- Compteur de visiteurs en direct (page produit) ---- */
(function () {
  var el = document.getElementById('product-viewers');
  if (!el) return;
  var count = Math.floor(Math.random() * 18) + 5;
  el.textContent = count;
  setInterval(function () {
    var delta = Math.random() > 0.5 ? 1 : -1;
    count = Math.max(3, Math.min(28, count + delta));
    el.textContent = count;
  }, 5000);
})();

/* ---- Ajout panier AJAX ---- */
(function () {
  const addForms = document.querySelectorAll('.product-form');
  addForms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const data = new FormData(form);
      const originalHTML = btn.innerHTML;

      // Reset état précédent
      btn.disabled = true;
      btn.classList.remove('btn--success', 'btn--error');
      btn.innerHTML = '<span>Ajout en cours…</span>';

      fetch('/cart/add.js', {
        method: 'POST',
        body: data,
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
      })
        .then(function (r) {
          return r.json().then(function (body) {
            if (!r.ok) {
              throw new Error(body.description || body.message || 'Erreur lors de l\'ajout au panier');
            }
            return body;
          });
        })
        .then(function (item) {
          btn.innerHTML = '<span>✓ Ajouté au panier</span>';
          btn.classList.add('btn--success');
          updateCartCount();
          // Redirection vers le panier après 600ms (UX claire pour l'utilisateur)
          setTimeout(function () { if (window.sosOpenCart) { btn.disabled = false; btn.innerHTML = originalHTML; window.sosOpenCart(); } else { window.location.href = '/cart'; } }, 600);
        })
        .catch(function (err) {
          btn.disabled = false;
          btn.innerHTML = originalHTML;
          btn.classList.add('btn--error');
          // Afficher l'erreur sous le bouton
          var existing = form.querySelector('.product-add-error');
          if (existing) existing.remove();
          var msg = document.createElement('p');
          msg.className = 'product-add-error';
          msg.style.cssText = 'margin:10px 0 0;padding:10px 14px;background:#fef2f2;border:1px solid #fecaca;border-radius:8px;color:#b91c1c;font-size:13px;font-weight:600';
          msg.textContent = (err && err.message) || 'Erreur lors de l\'ajout au panier. Veuillez réessayer.';
          form.appendChild(msg);
          setTimeout(function () {
            btn.classList.remove('btn--error');
            if (msg.parentNode) msg.remove();
          }, 5000);
        });
    });
  });

  function updateCartCount() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        const counters = document.querySelectorAll('.cart-count');
        counters.forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      });
  }
})();

/* ---- Sélecteur de quantité ---- */
/* 13/09/2026 — CORRECTIF : écrire `input.value = …` depuis un script ne déclenche
   AUCUN événement. Les boutons + et − changeaient donc le chiffre à l'écran sans
   jamais prévenir personne : dans le panier, /cart/change.js n'était pas appelé et
   le total de ligne restait figé sur l'ancienne quantité (constaté par Fabrice :
   quantité affichée 2, total affiché 104,65 € = 5 × 20,93 €). On émet maintenant un
   `change` explicite, qui est ce qu'écoute la mise à jour du panier plus bas.
   On respecte aussi l'attribut max du champ (10 dans le panier). */
(function () {
  const containers = document.querySelectorAll('.qty-selector');
  containers.forEach(function (container) {
    const minus = container.querySelector('.qty-minus');
    const plus = container.querySelector('.qty-plus');
    const input = container.querySelector('.qty-input');
    if (!minus || !plus || !input) return;

    let max = parseInt(input.getAttribute('max'), 10);
    if (isNaN(max) || max < 1) max = 99;
    let min = parseInt(input.getAttribute('min'), 10);
    if (isNaN(min) || min < 1) min = 1;

    function poser(v) {
      if (String(input.value) === String(v)) return;
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    minus.addEventListener('click', function () {
      const val = parseInt(input.value, 10) || min;
      if (val > min) poser(val - 1);
    });
    plus.addEventListener('click', function () {
      const val = parseInt(input.value, 10) || min;
      if (val < max) poser(val + 1);
    });
  });
})();

/* ---- Panier : mise à jour quantité ---- */
/* 13/09/2026 — le rechargement est retardé de 450 ms : trois clics rapides sur « + »
   ne déclenchent plus trois allers-retours et trois rechargements, mais un seul,
   avec la quantité finale. Un échec réseau recharge quand même la page, pour ne
   jamais laisser un total faux à l'écran. */
(function () {
  const cartItems = document.querySelectorAll('.cart-item-qty');
  let enAttente = null;
  cartItems.forEach(function (input) {
    input.addEventListener('change', function () {
      const key = input.getAttribute('data-key');
      const qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 0) return;
      clearTimeout(enAttente);
      enAttente = setTimeout(function () {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ id: key, quantity: parseInt(input.value, 10) })
        })
          .then(function (r) { return r.json(); })
          .then(function () { location.reload(); })
          .catch(function () { location.reload(); });
      }, 450);
    });
  });
})();

/* ---- Notifications toast ---- */
window.SOSToast = (function () {
  function show(message, type) {
    type = type || 'info';
    const toast = document.createElement('div');
    toast.className = 'sos-toast sos-toast--' + type;
    toast.textContent = message;
    document.body.appendChild(toast);
    requestAnimationFrame(function () {
      toast.classList.add('sos-toast--visible');
    });
    setTimeout(function () {
      toast.classList.remove('sos-toast--visible');
      setTimeout(function () { toast.remove(); }, 400);
    }, 3500);
  }
  return { show: show };
})();

/* ---- Galerie produit (miniatures) ---- */
(function () {
  const galleries = document.querySelectorAll('.product-gallery');
  galleries.forEach(function (gallery) {
    const main = gallery.querySelector('.gallery-main img');
    const thumbs = gallery.querySelectorAll('.gallery-thumb');
    if (!main || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        main.src = thumb.getAttribute('data-src') || thumb.querySelector('img').src;
        main.alt = thumb.querySelector('img') ? thumb.querySelector('img').alt : '';
      });
    });
  });
})();

/* ---- Animation au scroll — progressive enhancement ---- */
(function () {
  // Activer les animations CSS seulement si IntersectionObserver disponible
  if (!('IntersectionObserver' in window)) return;

  // Activer la classe qui cache les éléments par défaut
  document.documentElement.classList.add('js-animations');

  // Stagger: délai progressif sur les enfants d'une même grille
  function applyStagger(parent) {
    var children = parent.querySelectorAll('.animate-on-scroll');
    children.forEach(function (el, i) {
      el.style.transitionDelay = (i * 70) + 'ms';
    });
  }
  document.querySelectorAll(
    '.products-grid, .trust-bar-grid, .categories-grid, ' +
    '.why-us-grid, .testimonials-grid, .steps-grid, .footer-grid'
  ).forEach(applyStagger);

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0, rootMargin: '0px 0px 0px 0px' });

  document.querySelectorAll('.animate-on-scroll').forEach(function (el) {
    observer.observe(el);
  });
})();

/* ---- Compteurs animés (stats) ---- */
(function () {
  if (!('IntersectionObserver' in window)) return;
  var counters = document.querySelectorAll('[data-counter]');
  if (!counters.length) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var target = parseInt(el.getAttribute('data-counter'), 10);
      var duration = 1800;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.floor(eased * target).toLocaleString('fr-FR');
        if (progress < 1) requestAnimationFrame(step);
        else el.textContent = target.toLocaleString('fr-FR');
      }
      requestAnimationFrame(step);
      obs.unobserve(el);
    });
  }, { threshold: 0.5 });
  counters.forEach(function (el) { obs.observe(el); });
})();

/* ---- Badge "X personnes regardent" — urgence dynamique ---- */
(function () {
  var badge = document.getElementById('live-viewers');
  if (!badge) return;
  function randomBetween(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  var count = randomBetween(8, 23);
  badge.textContent = count;
  setInterval(function () {
    var delta = Math.random() > 0.5 ? 1 : -1;
    count = Math.max(5, Math.min(35, count + delta));
    badge.textContent = count;
  }, 4500);
})();

/* ---- Notifications toast achat récent — DÉSACTIVÉ ---- */

/* ---- Newsletter AJAX submission (évite reload + erreur Safari) ---- */
(function () {
  var form = document.getElementById('v4-newsletter-form');
  if (!form) return;
  var btn = form.querySelector('.v4-news__btn');
  var btnLabel = form.querySelector('.v4-news__btn-label');
  var feedback = form.querySelector('.v4-news__feedback');
  var emailInput = form.querySelector('input[type="email"]');

  function showMsg(text, ok) {
    if (!feedback) return;
    feedback.textContent = text;
    feedback.classList.remove('v4-news__feedback--ok','v4-news__feedback--err');
    feedback.classList.add(ok ? 'v4-news__feedback--ok' : 'v4-news__feedback--err');
    feedback.hidden = false;
    requestAnimationFrame(function () { feedback.setAttribute('data-show','1'); });
    if (ok) {
      setTimeout(function () {
        feedback.setAttribute('data-show','0');
        setTimeout(function () { feedback.hidden = true; }, 350);
      }, 5000);
    }
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!emailInput || !emailInput.value) return;
    if (btn) { btn.disabled = true; if (btnLabel) btnLabel.textContent = 'Envoi…'; }
    var data = new FormData(form);
    fetch(form.action || window.location.pathname, {
      method: 'POST',
      body: data,
      headers: { 'Accept': 'text/html' },
      credentials: 'same-origin'
    }).then(function () {
      showMsg('🎉 Merci ! Votre code BIENVENUE20 arrive par email — vérifiez vos spams si besoin.', true);
      form.reset();
    }).catch(function () {
      // Même en cas d'erreur réseau, Shopify a souvent bien reçu — message positif par défaut
      showMsg('🎉 Merci ! Votre inscription a bien été enregistrée. Votre code arrive par email.', true);
      form.reset();
    }).finally(function () {
      if (btn) { btn.disabled = false; if (btnLabel) btnLabel.textContent = 'Recevoir mes offres VIP'; }
    });
  });
})();

/* ---- Auto-dismiss bannière de confirmation newsletter (injection app) ---- */
(function () {
  // Doit contenir AU MOINS UN de ces motifs très spécifiques (pas juste "BIENVENUE10",
  // sinon on virerait le bandeau promo permanent en haut du site).
  var REQUIRED_PATTERNS = [/arrive par email/i, /v[ée]rifiez vos spams/i, /spams si besoin/i];
  var AUTO_HIDE_MS = 4500;
  var FADE_MS = 400;
  var seen = new WeakSet();

  function isInsideExcluded(el) {
    // Ne JAMAIS toucher au bandeau promo permanent ni au header
    return !!el.closest('#promoBandeau, .promo-bandeau, .site-header, .header, header, [data-no-autohide]');
  }

  function dismiss(el) {
    if (!el || seen.has(el)) return;
    seen.add(el);
    setTimeout(function () {
      el.style.transition = 'opacity ' + FADE_MS + 'ms ease, transform ' + FADE_MS + 'ms ease';
      el.style.opacity = '0';
      el.style.transform = 'translateY(-10px)';
      setTimeout(function () {
        if (el.parentNode) el.parentNode.removeChild(el);
      }, FADE_MS + 50);
    }, AUTO_HIDE_MS);
  }

  function maybeDismiss(node) {
    if (!node || node.nodeType !== 1 || seen.has(node)) return;
    if (isInsideExcluded(node)) return;
    var txt = (node.innerText || node.textContent || '').trim();
    if (!txt || txt.length > 400) return;
    var match = REQUIRED_PATTERNS.some(function (rx) { return rx.test(txt); });
    if (!match) return;
    dismiss(node);
  }

  function scanNode(root) {
    if (!root || !root.querySelectorAll) return;
    maybeDismiss(root);
    // Cherche uniquement parmi les conteneurs susceptibles d'être une toast/popup
    var candidates = root.querySelectorAll('div, p, section, aside, [role="status"], [role="alert"]');
    candidates.forEach(maybeDismiss);
  }

  function start() {
    // Observer uniquement les éléments AJOUTÉS dynamiquement (pas le DOM initial)
    var mo = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes && m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1) scanNode(n);
        });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ---- Filtres collection ---- */
(function () {
  const filterForm = document.getElementById('collection-filters');
  if (!filterForm) return;

  const inputs = filterForm.querySelectorAll('input, select');
  inputs.forEach(function (input) {
    input.addEventListener('change', function () {
      filterForm.submit();
    });
  });

  const mobileToggle = document.getElementById('filter-toggle');
  const filterPanel = document.getElementById('filter-panel');
  if (mobileToggle && filterPanel) {
    mobileToggle.addEventListener('click', function () {
      filterPanel.classList.toggle('is-open');
      mobileToggle.setAttribute(
        'aria-expanded',
        filterPanel.classList.contains('is-open') ? 'true' : 'false'
      );
    });
  }
})();

